import { fetchApi } from "../utils/fetch-api";

export class StakeAPI {
  static async stake(payload) {
    try {
      const headers = {};

      const data = fetchApi({
        url: "/api/v1/staking/stake",
        options: {
          method: "POST",
          headers,
        },
        payload,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async userStakeDetails() {
    try {
      const headers = {};

      const data = fetchApi({
        url: "/api/v1/staking/user-details",
        options: {
          method: "GET",
          headers,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async withdrawStake(payload) {
    try {
      const headers = {};
      const data = fetchApi({
        url: "/api/v1/staking/withdraw-stake",
        options: {
          method: "POST",
          headers,
        },
        payload,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
}
